import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { scrollToId } from '../lib/scroll';

const navItems = [
  { label: 'Ortexo', page: 'ortexo', href: '/ortexo', isProduct: true },
  { label: 'Borderou', page: 'borderou', href: '/borderou', isProduct: true },
  { label: 'Plicuri', page: 'corespondenta', href: '/corespondenta', isProduct: true },
  { label: 'Companie', page: 'home', href: '/#companie' },
  { label: 'Misiune', page: 'home', href: '/#misiune' },
  { label: 'Echipă', page: 'home', href: '/#team' },
  { label: 'Contact', page: 'home', href: '/#contact' },
];

export const Header = ({ onNavigate, currentPage }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (e, item) => {
    if (!onNavigate) return;
    e.preventDefault();
    setIsMobileMenuOpen(false);
    if (item.isProduct) {
      onNavigate(item.page);
    } else if (item.href.startsWith('/#')) {
      // Navigate home first when the anchor lives on another page
      const target = item.href.replace('/', '');
      if (currentPage !== 'home') {
        onNavigate('home');
        setTimeout(() => scrollToId(target), 120);
      } else {
        scrollToId(target);
      }
    }
  };

  const handleLogoClick = (e) => {
    if (!onNavigate) return;
    e.preventDefault();
    onNavigate('home');
  };

  return (
    <>
      <header className={`header ${isScrolled ? 'header-scrolled' : ''}`}>
        <div className="header-inner container">
          <a href="/" onClick={handleLogoClick} style={{ textDecoration: 'none', display: 'flex', alignItems: 'center' }}>
            <img
              src="/polytoollogo2000.png"
              alt="Poly Tool"
              style={{
                height: isScrolled ? '68px' : '88px',
                width: 'auto',
                transition: 'height 300ms ease'
              }}
            />
          </a>

          <nav style={{ display: 'none' }} className="desktop-nav">
            {navItems.map((item) => (
              <a
                key={item.label}
                href={item.href}
                className={`nav-link${currentPage === item.page && item.isProduct ? ' nav-link-active' : ''}`}
                onClick={(e) => handleNavClick(e, item)}
              >
                {item.label}
              </a>
            ))}
          </nav>

          <button
            className="mobile-menu-btn"
            onClick={() => setIsMobileMenuOpen(true)}
            aria-label="Deschide meniul"
            style={{
              display: 'block',
              padding: '0.5rem',
              background: 'transparent',
              border: 'none',
              color: 'rgba(255, 255, 255, 0.6)',
              cursor: 'pointer'
            }}
          >
            <Menu size={20} />
          </button>
        </div>
      </header>

      {isMobileMenuOpen && (
        <div className="mobile-menu animate-fadeIn">
          <button
            style={{
              position: 'absolute',
              top: '1.25rem',
              right: '1.25rem',
              background: 'transparent',
              border: 'none',
              color: 'rgba(255, 255, 255, 0.5)',
              cursor: 'pointer',
              padding: '0.5rem'
            }}
            onClick={() => setIsMobileMenuOpen(false)}
            aria-label="Închide meniul"
          >
            <X size={24} />
          </button>

          <div style={{ marginBottom: '2rem' }}>
            <img src="/polytoollogo2000.png" alt="Poly Tool" style={{ height: '68px', width: 'auto' }} />
          </div>

          <nav style={{ display: 'flex', flexDirection: 'column' }}>
            {navItems.map((item) => (
              <a
                key={item.label}
                href={item.href}
                className="mobile-nav-link"
                onClick={(e) => handleNavClick(e, item)}
              >
                {item.label}
              </a>
            ))}
          </nav>
        </div>
      )}

      <style>{`
        @media (min-width: 860px) {
          .desktop-nav {
            display: flex !important;
            align-items: center;
            gap: 0;
          }
          .mobile-menu-btn {
            display: none !important;
          }
        }
        .nav-link-active {
          color: var(--copper) !important;
        }
      `}</style>
    </>
  );
};

export default Header;
